import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetWhiteDealerAdminAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/auth/WhiteDealerAdminAuth',
      requesterInfo,
    })
  }

  public async getWhiteAuth(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
